module.exports = __webpack_public_path__ + "img/img19.907c7ffa.png";